const CONTROL_CHAR_THRESHOLD = 32; // U+0000–U+001F (below ASCII space)

export const sanitizeCid = (raw) => {
  if (!raw || typeof raw !== 'string') {
    return null;
  }

  let value = raw.trim();
  value = value.replace(/[<>]/g, '');
  if ([...value].some(c => c.charCodeAt(0) < CONTROL_CHAR_THRESHOLD)) {
    return null;
  }

  if (!/^[A-Za-z]{2}_\d{6}$/.test(value)) {
    return null;
  }

  return value || null;
};

export const getCid = () => sessionStorage.getItem('cid') || 'Organic';
